import { ENGINE_MATCHER_ALL } from '../../logger/constants';
export function allMatcherContext(log) {
    return function allMatcher(runtimeAttr) {
        log.debug(ENGINE_MATCHER_ALL);
        return runtimeAttr != null;
    };
}
